class SwiperSlider extends HTMLElement {
  constructor() {
    super();
    this._config = null;
    this.hasInitialized = false;
    this.swiperInstance = null;
  }

  connectedCallback() {
    window.addEventListener('resize', this.handleLoadOrResize.bind(this));
    this.handleLoadOrResize(); // Initial check on load
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleLoadOrResize.bind(this));
  }

  set config(newConfig) {
    this._config = newConfig;
    if (this.isConnected && !this.hasInitialized) {
      this.handleLoadOrResize(); // Ensure proper initialization on config update
    }
  }

  get config() {
    return this._config;
  }

  initializeSwiper(config) {
    if (this.hasInitialized) return;

    const defaultConfig = {
      slidesPerView: 1.5,
      spaceBetween: 10,
      loop: false,
      freeMode: true,
      grabCursor: true,
      breakpoints: {
        575: { slidesPerView: 2, spaceBetween: 15 },
        768: { slidesPerView: 2.5, spaceBetween: 20 },
        992: { slidesPerView: 3, spaceBetween: 25 },
        1200: { slidesPerView: 5, spaceBetween: 35 },
      },
    };

    const finalConfig = { ...defaultConfig, ...config };

    this.swiperInstance = new Swiper(this.querySelector('.swiper'), finalConfig);
    this.hasInitialized = true;
  }

  destroySwiper() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
      this.hasInitialized = false;
    }
  }

  handleLoadOrResize() {
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const shouldUseGrid = this.hasAttribute('grid-mobile');
    const swiperWrapper = this.querySelector('.swiper-wrapper');

    if (isMobile && shouldUseGrid) {
      this.destroySwiper();
      swiperWrapper?.classList.add('mobile-grid'); // Add Tailwind grid styling
    } else {
      swiperWrapper?.classList.remove('mobile-grid');
      if (!this.hasInitialized && this._config) {
        this.initializeSwiper(this._config);
      }
    }
  }
}

customElements.define('swiper-slider', SwiperSlider);